/**
 * @fileoverview POST handler for the "/engagement/webhook_templates/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementWebhookTemplatesIdCacheKeys } from "./constants";
import type { PostEngagementWebhookTemplatesIdProps, PostEngagementWebhookTemplatesIdResponse } from "./types";

export const postEngagementWebhookTemplatesId = reactQueryMutationAdapter(
  engagementWebhookTemplatesIdCacheKeys,
  (props: PostEngagementWebhookTemplatesIdProps): Promise<PostEngagementWebhookTemplatesIdResponse> => {
    return fetch(`/engagement/webhook_templates/${props.id}`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
